// onetop GEO Landingpage - Interactive Features

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();
  initMobileMenu();
  initScrollReveal();
  initCountUp();
  initFaqAccordion();
});

/**
 * 1. Sticky Navigation Bar with dynamic blur/background on scroll
 */
function initStickyHeader() {
  const header = document.getElementById('main-header');
  if (!header) return;

  const updateHeader = () => {
    if (window.scrollY > 20) {
      header.classList.add('shadow-soft');
    } else {
      header.classList.remove('shadow-soft');
    }
  };

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();
}

/**
 * 2. Accessible Mobile Menu Drawer
 */
function initMobileMenu() {
  const toggleBtn = document.getElementById('mobile-menu-toggle');
  const menuDrawer = document.getElementById('mobile-menu');
  const menuBackdrop = document.getElementById('mobile-backdrop');
  const closeBtn = document.getElementById('mobile-menu-close');
  const navLinks = document.querySelectorAll('.mobile-nav-link');

  if (!toggleBtn || !menuDrawer) return;

  const openMenu = () => {
    menuDrawer.classList.remove('translate-x-full');
    if (menuBackdrop) {
      menuBackdrop.classList.remove('opacity-0', 'pointer-events-none');
      menuBackdrop.classList.add('opacity-100', 'pointer-events-auto');
    }
    document.body.classList.add('overflow-hidden');
    toggleBtn.setAttribute('aria-expanded', 'true');
  };

  const closeMenu = () => {
    menuDrawer.classList.add('translate-x-full');
    if (menuBackdrop) {
      menuBackdrop.classList.add('opacity-0', 'pointer-events-none');
      menuBackdrop.classList.remove('opacity-100', 'pointer-events-auto');
    }
    document.body.classList.remove('overflow-hidden');
    toggleBtn.setAttribute('aria-expanded', 'false');
  };

  toggleBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (menuBackdrop) menuBackdrop.addEventListener('click', closeMenu);

  navLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !menuDrawer.classList.contains('translate-x-full')) {
      closeMenu();
    }
  });
}

/**
 * 3. Fluid IntersectionObserver-based Scroll Reveal
 */
function initScrollReveal() {
  const revealElements = document.querySelectorAll('.reveal-item');
  if (!revealElements.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -60px 0px',
    threshold: 0.1
  });

  revealElements.forEach(el => observer.observe(el));
}

/**
 * 4. Animated KPI Count-Up
 */
function initCountUp() {
  const counterElements = document.querySelectorAll('[data-counter-target]');
  if (!counterElements.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });

  counterElements.forEach(el => observer.observe(el));

  function animateCounter(el) {
    const target = parseFloat(el.getAttribute('data-counter-target'));
    const prefix = el.getAttribute('data-counter-prefix') || '';
    const suffix = el.getAttribute('data-counter-suffix') || '';
    const duration = parseInt(el.getAttribute('data-counter-duration') || '1600', 10);
    const isDecimal = target % 1 !== 0;

    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      // Ease out cubic
      const ease = 1 - Math.pow(1 - progress, 3);
      const current = target * ease;

      el.textContent = `${prefix}${isDecimal ? current.toFixed(1) : Math.round(current)}${suffix}`;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = `${prefix}${isDecimal ? target.toFixed(1) : target}${suffix}`;
      }
    }

    requestAnimationFrame(step);
  }
}

/**
 * 5. Accessible FAQ Accordion
 */
function initFaqAccordion() {
  const items = document.querySelectorAll('.faq-accordion-item');
  if (!items.length) return;

  items.forEach(item => {
    const trigger = item.querySelector('.faq-accordion-trigger');
    const content = item.querySelector('.accordion-content');
    const icon = item.querySelector('.faq-icon');

    if (!trigger || !content) return;

    content.style.maxHeight = null;

    trigger.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      // Close all other items in same group
      items.forEach(otherItem => {
        if (otherItem !== item) {
          const otherTrigger = otherItem.querySelector('.faq-accordion-trigger');
          const otherContent = otherItem.querySelector('.accordion-content');
          const otherIcon = otherItem.querySelector('.faq-icon');
          if (otherTrigger && otherContent) {
            otherTrigger.setAttribute('aria-expanded', 'false');
            otherContent.classList.remove('is-open');
            otherContent.style.maxHeight = null;
            if (otherIcon) otherIcon.classList.remove('rotate-180');
          }
        }
      });

      // Toggle current item
      if (isExpanded) {
        trigger.setAttribute('aria-expanded', 'false');
        content.classList.remove('is-open');
        content.style.maxHeight = null;
        if (icon) icon.classList.remove('rotate-180');
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        content.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
        if (icon) icon.classList.add('rotate-180');
      }
    });
  });
}



